/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as OrdersIndexRouteImport } from './routes/orders/index'
import { Route as LegalDocumentsIndexRouteImport } from './routes/legal-documents/index'
import { Route as FeatureFlagsIndexRouteImport } from './routes/feature-flags/index'
import { Route as CatalogIndexRouteImport } from './routes/catalog/index'
import { Route as OrdersOrderIdRouteImport } from './routes/orders/$orderId'
import { Route as LegalDocumentsSlugRouteImport } from './routes/legal-documents/$slug'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersIndexRoute = OrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalDocumentsIndexRoute = LegalDocumentsIndexRouteImport.update({
  id: '/legal-documents/',
  path: '/legal-documents/',
  getParentRoute: () => rootRouteImport,
} as any)
const FeatureFlagsIndexRoute = FeatureFlagsIndexRouteImport.update({
  id: '/feature-flags/',
  path: '/feature-flags/',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogIndexRoute = CatalogIndexRouteImport.update({
  id: '/catalog/',
  path: '/catalog/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrdersOrderIdRoute = OrdersOrderIdRouteImport.update({
  id: '/orders/$orderId',
  path: '/orders/$orderId',
  getParentRoute: () => rootRouteImport,
} as any)
const LegalDocumentsSlugRoute = LegalDocumentsSlugRouteImport.update({
  id: '/legal-documents/$slug',
  path: '/legal-documents/$slug',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/legal-documents/$slug': typeof LegalDocumentsSlugRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/catalog/': typeof CatalogIndexRoute
  '/feature-flags/': typeof FeatureFlagsIndexRoute
  '/legal-documents/': typeof LegalDocumentsIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/legal-documents/$slug': typeof LegalDocumentsSlugRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/catalog': typeof CatalogIndexRoute
  '/feature-flags': typeof FeatureFlagsIndexRoute
  '/legal-documents': typeof LegalDocumentsIndexRoute
  '/orders': typeof OrdersIndexRoute
  '/settings': typeof SettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/legal-documents/$slug': typeof LegalDocumentsSlugRoute
  '/orders/$orderId': typeof OrdersOrderIdRoute
  '/catalog/': typeof CatalogIndexRoute
  '/feature-flags/': typeof FeatureFlagsIndexRoute
  '/legal-documents/': typeof LegalDocumentsIndexRoute
  '/orders/': typeof OrdersIndexRoute
  '/settings/': typeof SettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/legal-documents/$slug'
    | '/orders/$orderId'
    | '/catalog/'
    | '/feature-flags/'
    | '/legal-documents/'
    | '/orders/'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/legal-documents/$slug'
    | '/orders/$orderId'
    | '/catalog'
    | '/feature-flags'
    | '/legal-documents'
    | '/orders'
    | '/settings'
  id:
    | '__root__'
    | '/'
    | '/legal-documents/$slug'
    | '/orders/$orderId'
    | '/catalog/'
    | '/feature-flags/'
    | '/legal-documents/'
    | '/orders/'
    | '/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LegalDocumentsSlugRoute: typeof LegalDocumentsSlugRoute
  OrdersOrderIdRoute: typeof OrdersOrderIdRoute
  CatalogIndexRoute: typeof CatalogIndexRoute
  FeatureFlagsIndexRoute: typeof FeatureFlagsIndexRoute
  LegalDocumentsIndexRoute: typeof LegalDocumentsIndexRoute
  OrdersIndexRoute: typeof OrdersIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/': {
      id: '/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof OrdersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal-documents/': {
      id: '/legal-documents/'
      path: '/legal-documents'
      fullPath: '/legal-documents/'
      preLoaderRoute: typeof LegalDocumentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/feature-flags/': {
      id: '/feature-flags/'
      path: '/feature-flags'
      fullPath: '/feature-flags/'
      preLoaderRoute: typeof FeatureFlagsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/': {
      id: '/catalog/'
      path: '/catalog'
      fullPath: '/catalog/'
      preLoaderRoute: typeof CatalogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/orders/$orderId': {
      id: '/orders/$orderId'
      path: '/orders/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof OrdersOrderIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/legal-documents/$slug': {
      id: '/legal-documents/$slug'
      path: '/legal-documents/$slug'
      fullPath: '/legal-documents/$slug'
      preLoaderRoute: typeof LegalDocumentsSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LegalDocumentsSlugRoute: LegalDocumentsSlugRoute,
  OrdersOrderIdRoute: OrdersOrderIdRoute,
  CatalogIndexRoute: CatalogIndexRoute,
  FeatureFlagsIndexRoute: FeatureFlagsIndexRoute,
  LegalDocumentsIndexRoute: LegalDocumentsIndexRoute,
  OrdersIndexRoute: OrdersIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
